
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_22826","data-name":"Group 22826","transform":"translate(-926.639 512.811)"}},[_c('circle',{attrs:{"id":"Ellipse_293","data-name":"Ellipse 293","cx":"6.799","cy":"6.799","r":"6.799","transform":"translate(926.84 -512.609)","fill":"transparent"}}),_c('circle',{attrs:{"id":"Ellipse_294","data-name":"Ellipse 294","cx":"6.5","cy":"6.5","r":"6.5","transform":"translate(927.139 -512.311)","fill":"none","stroke":"#6b7786","stroke-width":"1"}}),_c('line',{attrs:{"id":"Line_373","data-name":"Line 373","y2":"13","transform":"translate(933.639 -512.311)","fill":"none","stroke":"#6b7786","stroke-width":"1"}}),_c('path',{attrs:{"id":"Path_1540","data-name":"Path 1540","d":"M927.139-506.33a24.206 24.206 0 006.473 1.039 24.864 24.864 0 006.527-1.039","fill":"none","stroke":"#6b7786","stroke-width":"1"}}),_c('g',{attrs:{"id":"Group_22825","data-name":"Group 22825"}},[_c('g',{attrs:{"id":"Group_22821","data-name":"Group 22821"}},[_c('g',{attrs:{"id":"Group_22819","data-name":"Group 22819"}},[_c('path',{attrs:{"id":"Path_1539","data-name":"Path 1539","d":"M935.076-499.389s4.418-7.327.222-12.747","fill":"none","stroke":"#6b7786","stroke-width":"1"}})])]),_c('g',{attrs:{"id":"Group_22824","data-name":"Group 22824"}},[_c('g',{attrs:{"id":"Group_22822","data-name":"Group 22822"}},[_c('path',{attrs:{"id":"Path_1539-2","data-name":"Path 1539","d":"M931.979-512.136c-4.2 5.42.223 12.747.223 12.747","fill":"none","stroke":"#6b7786","stroke-width":"1"}})])])])])])
          )
        }
      }
    